import dayjs from "dayjs";

export default class DateUtil {

    static FormatDate(timestamp, format = 'd/m/yy') {
        return dayjs(timestamp).format(format);
    }

    static MinutesToTimestamp(min) {
        return min * 60 * 1000
    }

    static CaculateTimeZone(timestamp) {
        const d = new Date();
        return timestamp + DateUtil.MinutesToTimestamp(d.getTimezoneOffset());
    }
}